export default [
  {
    path: '/meals/cookbook',
    translationKey: 'meals.mainScreen.categoryMenu.cookbookTab',
  },
  {
    path: '/meals/day-plan',
    translationKey: 'meals.mainScreen.categoryMenu.mealPlanTab',
  },
];
